import { FC } from 'react'

import { AttributeSection } from '@syconium/little-miss-figgy'

import { usePortal } from '../../../../../../app/_providers/PortalProvider.client'
import { useTranslation } from '../../../../../../app/_providers/TranslationProvider.client'
import { EmbroideryService } from '../../../../../../brunswick/containers/embroidery'
import { hashPrefixed } from '../../../../../../lib/utils/color'
import { LogoSneakPeek } from '../../embroidery/EmbroiderySneakPeek/LogoSneakPeek'
import { EmbroiderySectionTitle } from '../EmbroiderySectionTitle'
import { SectionWrapper } from '../styles'

export const PortalEmbroiderySection: FC = () => {
  const { productColorHex, productCategory, selectedEmbroideryOptions } =
    EmbroideryService.useContainer()
  const { hasMandatoryLogoEmbroidery } = usePortal()

  const logoSneakPeekBackgroundColor = hashPrefixed(productColorHex)

  const {
    embroidery: { logoTitle },
  } = useTranslation()

  const title = (
    <EmbroiderySectionTitle isRequired={hasMandatoryLogoEmbroidery(productCategory)}>
      {logoTitle}
    </EmbroiderySectionTitle>
  )

  return (
    <SectionWrapper data-testid='portal-embroidery-section'>
      <AttributeSection title={title}>
        <LogoSneakPeek
          backgroundColor={logoSneakPeekBackgroundColor}
          imgSrc={selectedEmbroideryOptions.LOGO_ONLY?.logoImageSource}
          logoName={selectedEmbroideryOptions.LOGO_ONLY?.logoName}
          logoPlacement={selectedEmbroideryOptions?.LOGO_ONLY?.logoPlacement}
        />
      </AttributeSection>
    </SectionWrapper>
  )
}
